import { View, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import React from 'react';
import FooterText from './FooterText';
import Icon from '../../icon/Icon';
import { ColorTokens, IconSizeTokens, IconTokens } from '@voltmoney/schema';
const FooterScreen = ({ homeIcon, transactionIcon, limitIcon, homeText, transactionText, limitText, handleHomeIcon, handleTransactionScreen, handleLimitScreen }) => {
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' } },
            React.createElement(View, { nativeID: 'txt_landingScreen_home' },
                React.createElement(TouchableOpacity, { style: styles.homeIconContainer, onPress: () => handleHomeIcon() },
                    React.createElement(View, { style: styles.iconContainer },
                        React.createElement(Icon, { name: IconTokens.HOME_BORROWER_LP, size: IconSizeTokens.XXXL, color: homeText ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal })),
                    React.createElement(FooterText, { label: "Home", screen: homeText }))),
            React.createElement(View, { style: { width: Platform.OS !== 'web' ? 10 : 50 } }),
            React.createElement(View, { nativeID: 'txt_landingScreen_transactions' },
                React.createElement(TouchableOpacity, { style: styles.transactionIconContainer, onPress: () => handleTransactionScreen() },
                    React.createElement(View, { style: styles.iconContainer },
                        React.createElement(Icon, { name: IconTokens.TRANSACTION_BORROWER_LP, size: IconSizeTokens.XXXL, color: transactionText ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal })),
                    React.createElement(FooterText, { label: "Transactions", screen: transactionText }))),
            React.createElement(View, { style: { width: Platform.OS !== 'web' ? 10 : 50 } }),
            React.createElement(View, { nativeID: 'txt_landingScreen_manageLimit' },
                React.createElement(TouchableOpacity, { style: styles.limitIconContainer, onPress: () => handleLimitScreen() },
                    React.createElement(View, { style: styles.iconContainer },
                        React.createElement(Icon, { name: IconTokens.MANAGE_LIMIT_BORROWER_LP, size: IconSizeTokens.XXXL, color: limitText ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal })),
                    React.createElement(FooterText, { label: "Manage Limit", screen: limitText }))))));
};
export default FooterScreen;
const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        bottom: 0,
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: Platform.OS === 'ios' ? 24 : 12,
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        height: Platform.OS === 'ios' ? 80 : 68,
        zIndex: 99,
        width: '100%',
        borderColor: '#F1F3F5',
        ...Platform.OS !== 'ios' && {
            borderWidth: 1
        },
        elevation: 20,
        boxShadow: Platform.OS === 'web' && '0 1px 6px 0 rgba(208, 213, 221, 0.25)',
        ...Platform.OS === 'ios' && {
            shadowOffset: { width: 0, height: 6 },
            shadowOpacity: 1,
            shadowRadius: 6,
            shadowColor: '#D0D5DD',
            paddingBottom: 18,
            borderTopWidth: 1,
        }
    },
    icon: {
        height: 28,
        width: 28,
    },
    homeIconContainer: {
        // paddingLeft:40,
        justifyContent: 'center',
        alignItems: 'center',
    },
    transactionIconContainer: {
        marginHorizontal: 28,
        justifyContent: 'center',
        alignItems: 'center',
    },
    limitIconContainer: {
        // paddingRight:40,
        justifyContent: 'center',
        alignItems: 'center',
    },
    iconContainer: {
        paddingHorizontal: 18,
    },
});
